<template>
	<o-card
		:id="`time-ticket-week-card-${setup.timeTicket.weekNumber}`"
		class="time-ticket-week-card"
		:class="{ 'time-ticket-week-card--current': setup.isCurrentWeek }"
		header-line
		@click="setup.storeScrollAndNavigate()">
		<template #header>
			<div class="week__picto">
				<o-icon font-icon="icon-interface-calendar-mark"/>
			</div>
			<div>
				<div class="week__index">Semaine {{ setup.timeTicket.weekNumber }}</div>
				<div class="week__dates">{{ setup.timeTicket.readableDates }}</div>
			</div>
		</template>

		<div class="week__circles">
			<time-ticket-week-circle
				color="info"
				label="À saisir par l'intérimaire"
				:value="setup.timeTicket.qtyPending"/>
			<time-ticket-week-circle
				color="warning-alt"
				:label="setup.timeTicket.labelToFillClient"
				:value="setup.timeTicket.qtyToValidate"/>
			<time-ticket-week-circle
				color="success"
				label="Validés"
				:value="setup.timeTicket.qtyValidated"/>
			<time-ticket-week-circle
				color="pink"
				label="Intégrés"
				:value="setup.timeTicket.qtyIntegrated"/>
		</div>
	</o-card>
</template>

<script setup lang="ts">
import TimeTicketWeekCardSetupService from '@/setup/time-ticket/TimeTicketWeekCardSetupService';
import TimeTicketWeekCircle from '@/components/time-ticket/TimeTicketWeekCircle.vue';
const props = defineProps(TimeTicketWeekCardSetupService.props);
const setup = new TimeTicketWeekCardSetupService(props);
</script>

<style scoped lang="less">
@import '@/styles/mixins';

.time-ticket-week-card,
.time-ticket-week-sticker {
  .week {
    &__picto {
      .circle(3.75rem);
      .flex-align();
      font-size: 1.75rem;
      background-color: var(--grey-lighter);
      margin-right: 0.9rem;
    }

    &__index {
      color: var(--grey-darker);
      font-weight: bold;
    }

    &__dates {
      color: var(--grey);
    }

    &__percentage {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.9rem;
    }

    &__circles {
      display: flex;
      flex-direction: column;
      width: fit-content;
      margin: auto;
      gap: 0.9rem;
    }
  }

  &--current .week__picto {
    background-color: var(--info);
    color: white;
  }
}

.time-ticket-week-card {
  height: 100%;

  :deep(.orion-card__header) {
    display: flex;
    align-items: center;
    font-size: 0.9rem;
    line-height: 1.3rem;
  }
}
</style>
